export enum MolliePaymentState {
    Open = "open",
    Canceled = "canceled",
    Pending = "pending",
    Authorized = "authorized",
    Expired = "expired",
    Failed = "failed",
    Paid = "paid"
}
